import { type Location } from '../../../models/Scheduling'
import { useAppSelector } from '../../../store/hooks'
import { selectSafeAuthenticatedUser } from '../../../store/auth/authSlice'
import {
  useGetAccountSchedulingSettingsQuery,
  useGetUserSchedulingLocationsQuery,
  useGetUserSchedulingSettingsQuery,
} from '../../../store/scheduling/scheduling'

export interface DefaultLocationPreviews {
  accountDefaultLocation?: Location
  userDefaultLocation?: Location
}

export const useDefaultLocationPreviews = (accountLocations: Location[]): DefaultLocationPreviews => {
  const { accountId, id: userId } = useAppSelector(selectSafeAuthenticatedUser)
  const { data: accountSettings } = useGetAccountSchedulingSettingsQuery({ accountId })
  const { data: userSettings } = useGetUserSchedulingSettingsQuery({ accountId, userId })
  const { data: userLocations } = useGetUserSchedulingLocationsQuery({ accountId, userId })
  const allLocations = [...accountLocations, ...(userLocations ?? [])]
  return {
    accountDefaultLocation: allLocations.find((location) => location.id === accountSettings?.defaults?.locationId),
    userDefaultLocation: allLocations.find((location) => location.id === userSettings?.defaults?.locationId),
  }
}
